<template>
  <div class="weihai-app-download">
    <!-- 下载微海APP 按钮 -->
    <div
      class="weihai-app-download-btn"
      @mouseenter="handleMouseover($event)"
      @mouseleave="handleMouseleave($event)"
    >
      <!-- 小图标，可自行替换成真实图片或 iconfont -->
      <img
        class="app-download-icon"
        src="https://manwei01.mwdwz.com/frontend/weihaiapp/weihai-app-download-icon.png"
      />
      <span>{{ i18nText.buttonText }}</span>
    </div>

    <!-- 弹框，使用过渡实现弹出收起的动画 -->
    <transition name="fade-popup">
      <div
        v-if="showPopup"
        class="weihai-app-download-popup"
        :style="popupStyleOverride"
        @mouseenter="handleMouseover($event)"
        @mouseleave="handleMouseleave($event)"
      >
        <!-- 右上角倒计时文字（首次弹出时才显示） -->
        <div v-if="isFirstTime && countdown >= 0" class="popup-countdown">
          {{ countdown }}S
        </div>

        <!-- 弹框内容，可替换为真实二维码等 -->
        <div class="popup-bg">
          <img
            :src="lang === 'en' ? 'https://manwei01.mwdwz.com/frontend/weihaiapp/weihai-app-download-popup-en.png' : 'https://manwei01.mwdwz.com/frontend/weihaiapp/weihai-app-download-popup.png'"
            @load="handleImageLoad"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'WeihaiAppDownload',
  props: {
    // 传入的语言属性，支持 "zh-CN" / "en" 等
    lang: {
      type: String,
      default: 'zh-CN'
    },
    // 接受外部传入的覆盖样式
    popupStyleOverride: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showPopup: false, // 是否显示弹框
      countdown: 3, // 倒计时(3,2,1,0)
      countdownTimer: null,
      isFirstTime: false // 是否首次自动弹出
    }
  },
  computed: {
    // 简易多语言处理
    i18nText() {
      const textMap = {
        'zh-CN': {
          buttonText: '下载微海APP',
          countdownLabel: '倒计时'
        },
        en: {
          buttonText: 'Download Weihai APP',
          countdownLabel: 'Countdown'
        }
      }
      return textMap[this.lang] || textMap['zh-CN']
    }
  },
  mounted() {
    // 通过 localStorage 判断用户是否已经看过
    const hasSeen = localStorage.getItem('weihaiAppDownloadSeen') === 'true'
    if (!hasSeen) {
      // 首次进入自动弹出
      this.isFirstTime = true
      this.showPopup = true
    }
  },
  beforeDestroy() {
    // 清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
      this.isFirstTime = false
      this.showPopup = false
    }
  },
  methods: {
    handleImageLoad() {
      // 只有首次进入且图片加载完毕后才启动倒计时
      if (this.isFirstTime) {
        this.startCountdown()
      }
    },
    // 倒计时逻辑
    startCountdown() {
      this.countdown = 3
      this.countdownTimer = setInterval(() => {
        this.countdown--
        // 倒计时结束后关闭弹窗，并记为已看过
        if (this.countdown < 0) {
          clearInterval(this.countdownTimer)
          this.isFirstTime = false
          this.showPopup = false
          localStorage.setItem('weihaiAppDownloadSeen', 'true')
        }
      }, 1000)
    },
    // 鼠标移入显示弹框
    handleMouseover() {
      this.showPopup = true
    },
    // 鼠标移出隐藏弹框，先检查鼠标是否仍在组件内部
    handleMouseleave(event) {
      // 如果 relatedTarget 仍在当前组件内，则不关闭弹框
      if (this.$el.contains(event.relatedTarget)) {
        return
      }
      this.showPopup = false
    }
  }
}
</script>

<style lang="less" scoped>
.weihai-app-download {
  position: relative; // 保证弹框相对于按钮进行绝对定位
  display: inline-flex;
  align-items: center;
  margin-right: 10px;

  .weihai-app-download-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #C4C4C4;
    background: #F5F5F5;
    height: 24px;
    border-radius: 8px;
    cursor: pointer;
    padding: 0 8px;

    span {
      font-family: "PingFang SC", sans-serif;
      font-weight: 500;
      font-size: 10px;
      line-height: 100%;
      color: #252525;
    }

    .app-download-icon {
      width: 7px;
      height: 10px;
      margin-right: 4px;
    }
  }

  .weihai-app-download-popup {
    position: absolute;
    top: 40px;
    right: 0;
    width: 323px;
    height: 314px;
    z-index: 9999;

    .popup-bg {
      width: 100%;
      height: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
    }

    .popup-countdown {
      position: absolute;
      top: 18px;
      right: 30px;
      font-size: 12px;
      color: #6D8DF4;
    }
  }

  .fade-popup-enter-active,
  .fade-popup-leave-active {
    transition: opacity 0.3s;
  }
  .fade-popup-enter,
  .fade-popup-leave-to {
    opacity: 0;
  }
}
</style>
